import {i18n} from "../utils/commonHelper";
import {
    QUEUE_NAME_BILLING,
    QUEUE_NAME_BILLING_ES,
    QUEUE_NAME_FLOYD_RADIOLOGY,
    QUEUE_NAME_REFERRAL_WMNS_GEN
} from "../utils/constant";
import {getRealQueueName} from "../utils/queueHelper";

export const getAgentHelloMessage = (queueInfo, options) => {
    const {queueMessages, startQueueName, agentName, customerName, language, showTransferMessage, prescription} = options;

    let message = "";

    if (!message && queueInfo?.id && showTransferMessage) {
        message = queueMessages[queueInfo.id]?.TransferMessage;
    }

    if (!message && queueInfo?.id) {
        message = queueMessages[queueInfo.id]?.AgentHelloMessage;
    }

    if (!message) {
        const queueName = getRealQueueName(queueInfo?.name ?? startQueueName);
        if (prescription) {
            message = getAgentHelloMessageWithPrescriptionByQueue(queueName, agentName, prescription);
        } else {
            message = getAgentHelloMessageByQueue(queueName, agentName, language, showTransferMessage);
        }
    }

    return message.replaceAll("{customerName}", customerName).replaceAll("{agentName}", agentName);
}

export const getAgentHelloMessageByQueue = (queueName, agentName, language, showTransferMessage) => {
    let msg = `Hi, my name is ${agentName}, how can I help you?`;

    if (showTransferMessage) {
        msg = i18n.__("Hi, my name is %s! Give me one moment to review your request.", agentName);
    }

    if ([QUEUE_NAME_BILLING, QUEUE_NAME_BILLING_ES].includes(queueName)) {
        if (showTransferMessage) {
            msg = i18n.__("Hi, my name is %s, can I please have the patient’s Date of Birth or Responsible Person Number?", agentName);
        } else {
            msg = (language === 'es')
                ? `¡Hola, mi nombre es ${agentName}! ¿Podria darme su nombre y fecha de nacimiento o el número de la persona responsible?`
                : `Hi, my name is ${agentName}, can I please have the patient’s Date of Birth or Responsible Person Number?`;
        }
    }

    if (queueName === QUEUE_NAME_FLOYD_RADIOLOGY) {
        msg = `Hi, my name is ${agentName}. Can I please have the patient’s name and date of birth?`;
    }

    if (queueName === QUEUE_NAME_REFERRAL_WMNS_GEN) {
        msg = `Hi, my name is ${agentName} with Atrium Health referrals teams.`;
    }

    return msg;
}

export const getAgentHelloMessageWithPrescriptionByQueue = (queueName, agentName, prescription) => {
    let msg = `Hi, my name is ${agentName}. Please allow me 2 minutes to review this request.`;
    if (prescription?.additionalData && prescription?.additionalData?.length) {
        msg = msg + ' I will confirm when it is complete. ' +
            'If you disconnect before the request is confirmed it will be cancelled.';
    }
    return msg;
}
